import React, { useContext, useEffect, useRef, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import AppContext from "../../context/AppContext";
import { installmentListApi } from "../../service/CustomerSupport";
import { IoSearch } from "react-icons/io5";
import translations from "../common/Translations";
import CommonButton from "../common/CommonButton";

const ViewInstallment = () => {
    // State for header from API response
     const tableRef = useRef();
    const [header, setHeader] = useState(null);
    const [totalValue, setTotalValue] = useState(1);
    const [currentPage, setCurrentPage] = useState(0);
    const { projectId, theme, langMode } = useContext(AppContext);
    const [pageSize, setPageSize] = useState(10);
    const [accountNo, setAccountNo] = useState('');
    const [inputValue, setInputValue] = useState(""); // Temporary state for input
    const [installmentList, setInstallmentList] = useState([]);
    const [inactivePlans, setInactivePlans] = useState([]);
    const totalPages = Math.ceil(totalValue / pageSize) - 1;
    const startIndex = currentPage * pageSize;
    const endIndex = startIndex + pageSize;
    const totalItems = totalValue;
    const [planDetails, setPlanDetails] = useState(null);

    const [searchQuery, setSearchQuery] = useState("");

    const handleInputChange = (event) => {
        setInputValue(event.target.value); // Update temporary state
    };

   

    const goToPreviousPage = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
    };

    const goToNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const fetchInstallment = async () => {
        try {
            const data = await installmentListApi(accountNo, ((localStorage.getItem("projectId") || "").replace(/"/g, "")));

            if (data?.header?.code === 600 && data?.body?.value) {
                const { details = [], inActivePlan = [], ...rest } = data.body.value;
                setInstallmentList(details);      // Active installment details
                setInactivePlans(inActivePlan);   // Inactive plans list
                setTotalValue(details.length);    // Update total count
                setPlanDetails(rest);         // Update total count
            } else {
                setInstallmentList([]);
                setInactivePlans([]);
                setPlanDetails()
            }
        } catch (error) {
            console.error("Error fetching installments:", error);
        }
    };

    const handleSearch = () => {
        setAccountNo(inputValue); // Set the final value on search
    };
    
     useEffect(() => {
        if (inputValue.length === 0) {
          handleSearch();
        }
      }, [inputValue]);
    
    // Fetch installments when accountNo or selectedOrgId changes
    useEffect(() => {
        if (accountNo) {
            fetchInstallment();
        }
    }, [accountNo, JSON.parse(localStorage.getItem("selectedOrgId"))]);

    // useEffect(() => {
    //     fetchInstallment();
    // }, [accountNo, JSON.parse(localStorage.getItem("selectedOrgId"))]);

    const formatDate = (dateString) => {
        if (!dateString) return "N/A"; // Handle empty or null values
        return new Date(dateString).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        }); // Example: "05 Mar 2025"
    };

    const handlePrint = () => {
        const printContents = tableRef.current.innerHTML;
        const printWindow = window.open('', '', 'height=600,width=800');
        printWindow.document.write('<html><head><title>Print</title>');
        printWindow.document.write('<style>body{font-family:sans-serif;padding:20px;} table{width:100%;border-collapse:collapse;} th,td{border:1px solid #ccc;padding:8px;text-align:center;}</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write(printContents);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      };

    const convertToArabicNumbers = (phoneNo) => {
        const digits = phoneNo?.replace(/\D/g, '');

        const countryCode = digits?.slice(0, 3);
        const part1 = digits?.slice(3, 7); 
        const part2 = digits?.slice(7);   

        return `+(${countryCode}) ${part1} ${part2}`;
    };

    return (
        <div className="sm:w-full w-[90%] max-w-4xl mx-auto sm:p-6 p-3 flex flex-col gap-y-8">

            {/* Search Bar */}
            <div className="flex justify-between">
            <div className="flex justify-center">
                <div className="relative mt-1">
                    <input
                        id="account-search"
                        autoComplete="new-password" // Alternative to prevent autofill
                        type="text"
                        className={`block h-8 pt-2  text-sm text-gray-900 border border-gray-300  ${langMode === 'ar' ? 'rounded-r-md':'rounded-l-lg' }  w-36
                   focus:ring-blue-300 focus:border-blue-300  
                    ${theme === "dark"
                                ? "dark-mode  "
                                : theme === "high-contrast"
                                    ? "high-contrast  "
                                    : ""
                            }`}
                        placeholder={translations[langMode].search}
                        value={inputValue} // Bind temporary state to input
                        onChange={handleInputChange} // Update temporary state on input change
                    />
                </div>

                <button
                    onClick={handleSearch} // Update state on button click
                    className={`h-8 px-4 mt-1 bg-[#236DB4] text-white  ${langMode === 'ar' ? 'rounded-l-md':'rounded-r-md' } `}
                >
                    <IoSearch size={20} />{" "}
                </button>
            </div>

            {/* <div>
                <CommonButton onClick={handlePrint} variant="primary" className="pointer-events-auto !py-2" disabled={!planDetails}>
                    Print
                </CommonButton>
            </div> */}
            </div>
            <div ref={tableRef}>
            {/* Inactive Installment Plans Table */}
            {planDetails ? (
                <>
                        <div className="rounded-lg p-6 w-full ">
                            <h2 className="text-lg font-bold mb-4 text-gray-800 pb-2">{translations[langMode].instplanDetail}</h2>
                            <table className="min-w-full text-sm text-gray-700 border border-gray-300 whitespace-nowrap">
                                <tbody>
                                    <tr className="border-b border-gray-300">
                                        <th className="text-left font-semibold p-2">{translations[langMode].planId}:</th>
                                        <td className="p-2">{planDetails.planId}</td>
                                    </tr>
                                    <tr className="border-b border-gray-300">
                                        <th className="text-left font-semibold p-2">{translations[langMode].accno}:</th>
                                        <td className="p-2">{planDetails.accountNo}</td>
                                    </tr>
                                    <tr className="border-b border-gray-300">
                                        <th className="text-left font-semibold p-2">{translations[langMode].planActive}:</th>
                                        <td className={`p-2 font-bold ${planDetails.isActive ? "text-green-600" : "text-red-600"}`}>
                                            {planDetails.isActive ? "Yes" : "No"}
                                        </td>
                                    </tr>
                                    <tr className="border-b border-gray-300">
                                        <th className="text-left font-semibold p-2">{translations[langMode].planCreated}:</th>
                                        <td className="p-2">{formatDate(planDetails.createdDate)}</td>
                                    </tr>
                                    <tr className="border-b border-gray-300">
                                        <th className="text-left font-semibold p-2">{translations[langMode].outstaningAmt}:</th>
                                        <td className="p-2">{planDetails.outstandingAtCreation}</td>
                                    </tr>
                                    <tr className="border-b border-gray-300">
                                        <th className="text-left font-semibold p-2">{translations[langMode].Advamt}:</th>
                                        <td className="p-2">{planDetails.advanceAmount}</td>
                                    </tr>
                                    <tr className="border-b border-gray-300">
                                        <th className="text-left font-semibold p-2">{translations[langMode].AdvDate}:</th>
                                        <td className="p-2">{formatDate(planDetails.advancePaymentDate)}</td>
                                    </tr>
                                    <tr className="border-b border-gray-300">
                                        <th className="text-left font-semibold p-2">{translations[langMode].firstInsDate}:</th>
                                        <td className="p-2">{formatDate(planDetails.firstInstalmentDate)}</td>
                                    </tr>
                                    <tr>
                                        <th className="text-left font-semibold p-2">{translations[langMode].noOfInst}:</th>
                                        <td className="p-2">{planDetails.noOfInstalments}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                </>
            ) : (
                <p></p>
            )}

                <h3 className="text-sm font-semibold mb-3">{translations[langMode].customerDetails}</h3>
                <div className="overflow-x-auto mb-6">
                    <table className="min-w-full table-auto whitespace-nowrap">
                        <thead className="text-sm text-gray-700 border-b border-gray-300">
                            <tr className="bg-gray-100">
                                <th className="px-6 py-2">{translations[langMode].created_By}</th>
                                <th className="px-6 py-2">{translations[langMode].accountNo}</th>
                                <th className="px-6 py-2">{translations[langMode].civilId}</th>
                                <th className="px-6 py-2">{translations[langMode].phoneNo}</th>
                            </tr>
                        </thead>
                        <tbody className="text-sm text-gray-700">
                            <tr className="border-b border-gray-200">
                                <td className="px-6 py-2">{planDetails?.createdByName}</td>
                                <td className="px-6 py-2">{planDetails?.accountNo}</td>
                                <td className="px-6 py-2">{planDetails?.civilId}</td>
                                <td className="px-6 py-2">{planDetails?.phoneNo && convertToArabicNumbers(planDetails?.phoneNo)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            <h3 className="text-sm font-semibold mb-3">{translations[langMode].inactiveplane}</h3>
            <div className="overflow-x-auto mb-6">
                <table className="min-w-full table-auto whitespace-nowrap">
                    <thead className="text-sm text-gray-700 border-b border-gray-300">
                        <tr className="bg-gray-100">
                            <th className="px-6 py-2">{translations[langMode].planId}</th>
                            <th className="px-6 py-2">{translations[langMode].accno}</th>
                            <th className="px-6 py-2">{translations[langMode].cretDate}</th>
                            <th className="px-6 py-2">{translations[langMode].Advamt}</th>
                        </tr>
                    </thead>
                    <tbody className="text-sm text-gray-700">
                        {inactivePlans.map((plan, index) => (
                            <tr key={index} className="border-b border-gray-200">
                                <td className="px-6 py-2">{plan.id}</td>
                                <td className="px-6 py-2">{plan.accountNo}</td>
                                <td className="px-6 py-2">
                                    {formatDate(plan.createdDate)}
                                </td>
                                <td className="px-6 py-2">OMR {plan.advanceAmount.toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Active Installment Details Table */}
            <h3 className="text-sm font-semibold mb-3">{translations[langMode].activeInst}</h3>
            <div className="overflow-x-auto mb-6">
                <table className="min-w-full table-auto whitespace-nowrap">
                    <thead className="text-sm text-gray-700 border-b border-gray-300">
                        <tr className="bg-gray-100">
                            <th className="px-6 py-2">{translations[langMode].DetailId}</th>
                            <th className="px-6 py-2">{translations[langMode].PayAmt}</th>
                            <th className="px-6 py-2">{translations[langMode].payDate}</th>
                            <th className="px-6 py-2">{translations[langMode].Status}</th>
                        </tr>
                    </thead>
                    <tbody className="text-sm text-gray-700">
                        {installmentList.map((item, index) => (
                            <tr key={index} className="border-b border-gray-200">
                                <td className="px-6 py-2">{item.detailId}</td>
                                <td className="px-6 py-2">OMR {item.paymentAmount.toFixed(2)}</td>
                                <td className="px-6 py-2">
                                    {formatDate(item.paymentDate)}
                                </td>
                                <td className="px-6 py-2">
                                    {item.isPaid ? "Paid" : "Pending"}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            </div>
        </div>
    );
};

export default ViewInstallment;
